// client/src/components/ImageGen.js
import React from 'react';
import { useImageGen } from './useImageGen';
import ImageGenDesign from './ImageGenDesign';

function ImageGen() {
 const {
        // States
        manualPrompt, setManualPrompt,
        imageUrl, setImageUrl,
        loading, setLoading,
        error, setError,
        clients, setClients,
        selectedClientId, setSelectedClientId,
        displayedPrompt, setDisplayedPrompt,
        excelFile, setExcelFile,
        excelLoading, setExcelLoading,
        excelError, setExcelError,
        excelResults, setExcelResults,
        fileInputRef,
        bulkSelectedSizePreset, setBulkSelectedSizePreset,
        bulkOutputFormat, setBulkOutputFormat,
        logoFile, setLogoFile,
        allLogos, setAllLogos,
        selectedLogoId, setSelectedLogoId,
        selectedLogoUrl, setSelectedLogoUrl,
        logoFileInputRef,
        loadingLogoUpload, setLoadingLogoUpload,
        logoCrudError, setLogoCrudError,
        generatedImageRecords, setGeneratedImageRecords,
        logoCombineExcelFile, setLogoCombineExcelFile,
        logoCombineLoading, setLogoCombineLoading,
        logoCombineError, setLogoCombineError,
        logoCombineResults, setLogoCombineResults,
        originalCombineExcelData, setOriginalCombineExcelData,
        logoCombineFileInputRef,
        selectedSizePreset, setSelectedSizePreset,
        outputFormat, setOutputFormat,
        outputFormatForCombiner, setOutputFormatForCombiner,
        displayMode, setDisplayMode,
        availableSizePresets, availableFormats,



        // Handlers & Functions

        clearSingleGenerationStates,

        clearBulkGenerationStates,

        clearLogoCombinerStates,

        handleClientSelectChange,

        handleManualPromptChange,

        handleExcelFileChange,

        handleSizePresetChange,

        handleFormatChange,

        handleBulkSizePresetChange,

        handleBulkOutputFormatChange,

        handleLogoFileChange,

        handleLogoSelectChange,

        handleLogoCombineExcelChange,

        handleOutputFormatForCombinerChange,

        handleSingleGenerate,

        handleExcelUpload,

        handleUploadLogo,

        handleDeleteLogo,

        handleSingleDownload,

        handleBatchDownload,

        handleDownloadGeneratedExcel,

        handleProcessImagesWithSelectedLogo,

        handleDownloadLogoCombineExcel,

        handleBulkRegenerate,

        handleBulkDelete,

        isSingleGenDisabled,

        isBulkGenDisabled,

        isLogoCombinerDisabled,

        BACKEND_URL

    } = useImageGen();



    // Pass all necessary props to the design component

    const designProps = {

        // State variables

        manualPrompt, imageUrl, loading, error, clients, selectedClientId, displayedPrompt,

        excelFile, excelLoading, excelError, excelResults, fileInputRef,

        bulkSelectedSizePreset, bulkOutputFormat,

        logoFile, allLogos, selectedLogoId, selectedLogoUrl, logoFileInputRef,

        loadingLogoUpload, logoCrudError,

        generatedImageRecords,

        logoCombineExcelFile, logoCombineLoading, logoCombineError, logoCombineResults,

        logoCombineFileInputRef, originalCombineExcelData,

        selectedSizePreset, outputFormat,

        outputFormatForCombiner,

        displayMode, setDisplayMode,

        availableSizePresets, availableFormats,



        // Handlers and functions

        handleClientSelectChange, handleManualPromptChange,

        handleExcelFileChange, handleSizePresetChange, handleFormatChange,

        handleBulkSizePresetChange, handleBulkOutputFormatChange,

        handleLogoFileChange, handleLogoSelectChange,

        handleLogoCombineExcelChange, handleOutputFormatForCombinerChange,

        handleSingleGenerate, handleExcelUpload,

        handleUploadLogo, handleDeleteLogo,

        handleSingleDownload, handleBatchDownload,

        handleDownloadGeneratedExcel,

        handleProcessImagesWithSelectedLogo, handleDownloadLogoCombineExcel,

        handleBulkRegenerate, handleBulkDelete,

        isSingleGenDisabled, isBulkGenDisabled, isLogoCombinerDisabled,

        BACKEND_URL,setError

    };



    return <ImageGenDesign {...designProps} />;

}



export default ImageGen;